import 'whatwg-fetch'
import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'

const render = () => {
  const App = require('./App').default // eslint-disable-line global-require
  ReactDOM.render(
    <AppContainer>
      <App />
    </AppContainer>,
    document.getElementById('root'),
  )
}

if (
  document.body &&
  ['complete', 'loaded', 'interactive'].includes(document.readyState)
) {
  render()
} else {
  document.addEventListener('DOMContentLoaded', render, false)
}

// webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./App', () => {
    render()
  })
}
